import * as React from 'react';
import { Select, Radio } from 'antd';
const { Option } = Select;
import { IWidget } from 'common/schema/widget/Widget';
import { WidgetInputViewType } from 'common/schema/widget/input/WidgetInputViewType';
import { FormWidgetItem } from './wrapper/FormWidgetItem';
import { getWidgetInputViewType } from '../helper/getWidgetInputViewType';
import { getWidgetCheckboxOptions } from '../helper/getWidgetCheckboxOptions';
import { MetadataLogic } from 'common/schema/metadata/MetadataLogic';
import { RadioInput } from 'client/ui/form/input/RadioInput';
import { SelectInput } from 'client/ui/form/input/SelectInput';

export interface FormWidgetInputSingleChoiceViewProps {
  widget: IWidget;
}

export function FormWidgetInputSingleChoiceView(
  props: FormWidgetInputSingleChoiceViewProps
) {
  const { widget } = props;
  // Abbiamo un singolo metadato per i campi di testo
  const metadata = MetadataLogic.singleFromWidget(widget);
  const name = `values.${metadata.id}`;

  return (
    <FormWidgetItem name={name} widget={widget}>
      {getWidgetInputViewType(widget) === WidgetInputViewType.Radio ? (
        <RadioInput name={name} options={getWidgetCheckboxOptions(widget)} />
      ) : (
        <SelectInput
          name={name}
          placeholder={widget.input?.placeholder}
          allowClear={true}
        >
          {widget.input?.options.map((option, i) => (
            <Option key={option.value} value={option.value}>
              {option.label}
            </Option>
          ))}
        </SelectInput>
      )}
    </FormWidgetItem>
  );
}
